export default {
  namespaced: true,
  state: {
    role: null,
    user: null
  },
  mutations: {
    SET_ROLE (state, role) {
      state.role = role
    },
    SET_USER (state, userInfo) {
      state.user = userInfo
    }
  },
  actions: {
    commitChangeRole ({ commit }, role) {
      return new Promise(resolve => {
        commit('SET_ROLE', role)
        resolve()
      })
    },
    commitChangeUser ({ commit }, info) {
      return new Promise(resolve => {
        commit('SET_USER', info)
        resolve()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js